<template>
  <svg
    v-if="icon === 'chat-main'"
    :width="width ? width : 30"
    :height="height ? height : 24"
    viewBox="0 0 30 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.4006 5.77062V18.5992C29.4006 19.7927 28.9265 20.9373 28.0826 21.7812C27.2386 22.6251 26.0941 23.0992 24.9006 23.0992H5.10059C3.90711 23.0992 2.76252 22.6251 1.91861 21.7812C1.07469 20.9373 0.600586 19.7927 0.600586 18.5992V5.77062L14.5434 13.975C14.6819 14.0567 14.8398 14.0998 15.0006 14.0998C15.1614 14.0998 15.3193 14.0567 15.4578 13.975L29.4006 5.77062ZM24.9006 -0.300781C26.0078 -0.300955 27.0763 0.107111 27.9016 0.84535C28.7268 1.58359 29.2509 2.60017 29.3736 3.70062L15.0006 12.1552L0.627586 3.70062C0.750271 2.60017 1.27437 1.58359 2.09962 0.84535C2.92486 0.107111 3.99332 -0.300955 5.10059 -0.300781H24.9006Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-send'"
    :width="width ? width : 21"
    :height="height ? height : 20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.26553 0.461064L19.6915 9.54026C19.792 9.58978 19.8766 9.66643 19.9358 9.76155C19.995 9.85667 20.0263 9.96645 20.0263 10.0785C20.0263 10.1905 19.995 10.3003 19.9358 10.3954C19.8766 10.4905 19.792 10.5671 19.6915 10.6167L1.26433 19.6959C1.16109 19.7466 1.04546 19.7666 0.931195 19.7534C0.816932 19.7403 0.708855 19.6945 0.619836 19.6217C0.530818 19.5489 0.464609 19.452 0.429095 19.3426C0.393582 19.2332 0.390261 19.1159 0.419527 19.0047L2.24473 12.1107C2.27431 11.9991 2.33545 11.8985 2.4208 11.8208C2.50615 11.7431 2.61209 11.6917 2.72593 11.6727L10.9831 10.2963C11.0323 10.2881 11.0787 10.2678 11.1181 10.2372C11.1575 10.2066 11.1887 10.1667 11.2087 10.1211L11.2303 10.0491C11.2415 9.98233 11.2298 9.91377 11.1972 9.85452C11.1645 9.79526 11.1127 9.7488 11.0503 9.72266L10.9831 9.70347L2.68033 8.31987C2.56671 8.30066 2.46102 8.24914 2.3759 8.17147C2.29078 8.0938 2.22983 7.99326 2.20033 7.88186L0.419527 1.15346C0.389957 1.04215 0.393048 0.92468 0.428433 0.815077C0.463817 0.705474 0.53 0.608371 0.619077 0.535363C0.708154 0.462356 0.816362 0.416528 0.930779 0.403353C1.0452 0.390178 1.16099 0.410213 1.26433 0.461064H1.26553Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-edit'"
    :width="width ? width : 12"
    :height="height ? height : 12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M9.85701 6.00021C9.62031 6.00021 9.42843 6.19209 9.42843 6.42879V10.7144C9.42843 10.9511 9.23656 11.143 8.99986 11.143H1.2857C1.049 11.143 0.857123 10.9511 0.857123 10.7144V2.14312C0.857123 1.90642 1.049 1.71454 1.2857 1.71454H6.42849C6.66519 1.71454 6.85706 1.52267 6.85706 1.28597C6.85706 1.04927 6.66519 0.857422 6.42849 0.857422H1.2857C0.575626 0.857422 0 1.43305 0 2.14312V10.7144C0 11.4245 0.575626 12.0001 1.2857 12.0001H8.99988C9.70995 12.0001 10.2856 11.4245 10.2856 10.7144V6.42876C10.2856 6.19209 10.0937 6.00021 9.85701 6.00021Z"
        :fill="color"
      />
      <path
        d="M11.5203 0.480586C11.2125 0.172823 10.7952 -4.34422e-05 10.36 6.78033e-06C9.9245 -0.00124878 9.5067 0.171919 9.19984 0.480863L3.55475 6.12547C3.50792 6.17266 3.47259 6.23001 3.45147 6.29304L2.59435 8.86444C2.51954 9.08901 2.64095 9.33168 2.86552 9.40646C2.90909 9.42098 2.95472 9.42839 3.00062 9.42844C3.04663 9.42836 3.09235 9.42098 3.13605 9.40659L5.70744 8.54947C5.7706 8.52837 5.82798 8.49287 5.87501 8.44576L11.5201 2.80069C12.1608 2.16005 12.1609 1.1213 11.5203 0.480586ZM10.9141 2.19511L5.34273 7.76647L3.67818 8.32231L4.23231 6.65989L9.8058 1.08856C10.1122 0.78275 10.6085 0.783252 10.9143 1.08966C11.0604 1.23603 11.1427 1.43419 11.1434 1.64098C11.1439 1.84887 11.0613 2.04836 10.9141 2.19511Z"
        :fill="color"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'chat-repeat'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path :fill="color" d="M17 17H7v-3l-4 4l4 4v-3h12v-6h-2M7 7h10v3l4-4l-4-4v3H5v6h2V7Z" />
  </svg>
  <svg
    v-else-if="icon === 'chat-share'"
    :width="width ? width : 12"
    :height="height ? height : 12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9959 5.99679L6.52707 0V3.59216H5.89178C4.31808 3.59216 2.8385 4.20502 1.72568 5.31784C0.612854 6.43066 0 7.91025 0 9.48404V12L1.04956 10.85C2.45352 9.31183 4.44644 8.42203 6.52707 8.40179V11.9937L11.9959 5.99679ZM0.703217 10.1922V9.48404C0.703217 8.09811 1.24292 6.79504 2.2229 5.81506C3.20288 4.83508 4.50586 4.29538 5.89178 4.29538H7.23019V1.81467L11.0443 5.99679L7.23019 10.179V7.6983H6.5993C4.3797 7.6983 2.24524 8.60422 0.703217 10.1922Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-trash'"
    :width="width ? width : 12"
    :height="height ? height : 12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.144 1.71429H8.14399V1.28571C8.14399 0.575633 7.56836 0 6.85828 0H5.14399C4.43391 0 3.85827 0.575633 3.85827 1.28571V1.71429H0.858267C0.621565 1.71429 0.429688 1.90617 0.429688 2.14287C0.429688 2.37957 0.62159 2.57143 0.858267 2.57143H1.32411L2.14398 11.6104C2.1642 11.8317 2.3503 12.0009 2.57256 12H9.42971C9.65197 12.0009 9.83805 11.8318 9.85828 11.6104L10.6781 2.57143H11.144C11.3807 2.57143 11.5726 2.37955 11.5726 2.14285C11.5726 1.90614 11.3807 1.71429 11.144 1.71429ZM4.71541 1.28571C4.71541 1.04901 4.90728 0.857133 5.14399 0.857133H6.85828C7.09498 0.857133 7.28686 1.04901 7.28686 1.28571V1.71429H4.71543V1.28571H4.71541ZM9.03842 11.1428H2.96385L2.18685 2.57143H4.28685H9.81755L9.03842 11.1428Z"
      :fill="color"
    />
    <path
      d="M4.71467 9.82872C4.71462 9.82814 4.71459 9.82754 4.71454 9.82696L4.28596 3.82698C4.26916 3.59027 4.06365 3.41203 3.82697 3.42883C3.59027 3.44563 3.41203 3.65114 3.42883 3.88782L3.85741 9.88781C3.87341 10.1125 4.06069 10.2865 4.28599 10.286H4.31685C4.55297 10.2696 4.73109 10.0648 4.71467 9.82872Z"
      :fill="color"
    />
    <path
      d="M5.99987 3.42871C5.76317 3.42871 5.57129 3.62059 5.57129 3.85729V9.85728C5.57129 10.094 5.76317 10.2859 5.99987 10.2859C6.23657 10.2859 6.42845 10.094 6.42845 9.85728V3.85729C6.42845 3.62059 6.23657 3.42871 5.99987 3.42871Z"
      :fill="color"
    />
    <path
      d="M8.1739 3.42785C7.93719 3.41105 7.73171 3.5893 7.71491 3.826L7.28633 9.82599C7.26898 10.062 7.44626 10.2675 7.68231 10.2848C7.68304 10.2849 7.68374 10.2849 7.68447 10.285H7.71491C7.94021 10.2856 8.12749 10.1116 8.14349 9.88683L8.57207 3.88684C8.58886 3.65017 8.4106 3.44468 8.1739 3.42785Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-add_file'"
    :width="width ? width : 21"
    :height="height ? height : 24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8037 2.19623C15.8774 -0.732077 11.112 -0.732077 8.18877 2.19623L0.080798 10.3035C0.0279874 10.3563 2.87193e-05 10.4278 2.87193e-05 10.5024C2.87193e-05 10.577 0.0279874 10.6485 0.080798 10.7014L1.2271 11.8485C1.27949 11.9007 1.35042 11.93 1.42436 11.93C1.4983 11.93 1.56923 11.9007 1.62162 11.8485L9.7296 3.74121C10.7361 2.73402 12.075 2.18069 13.4978 2.18069C14.9206 2.18069 16.2595 2.73402 17.2629 3.74121C18.2694 4.7484 18.8223 6.08821 18.8223 7.50884C18.8223 8.93258 18.2694 10.2693 17.2629 11.2765L8.99957 19.5423L7.66067 20.8821C6.40875 22.1348 4.37399 22.1348 3.12206 20.8821C2.5163 20.2759 2.1839 19.4708 2.1839 18.6128C2.1839 17.7548 2.5163 16.9497 3.12206 16.3435L11.3201 8.143C11.5283 7.93783 11.8016 7.82281 12.0936 7.82281H12.0968C12.3888 7.82281 12.659 7.93783 12.8641 8.143C13.0722 8.35127 13.184 8.62483 13.184 8.91704C13.184 9.20614 13.0691 9.4797 12.8641 9.68486L6.16333 16.3839C6.11052 16.4368 6.08256 16.5083 6.08256 16.5829C6.08256 16.6575 6.11052 16.729 6.16333 16.7818L7.30963 17.9289C7.36203 17.9811 7.43296 18.0104 7.50689 18.0104C7.58083 18.0104 7.65176 17.9811 7.70416 17.9289L14.4018 11.2267C15.02 10.6081 15.3586 9.78745 15.3586 8.91393C15.3586 8.04041 15.0169 7.21663 14.4018 6.60113C13.125 5.32349 11.0499 5.3266 9.77309 6.60113L8.97782 7.40004L1.57813 14.8016C1.07591 15.3012 0.677801 15.8957 0.406904 16.5504C0.136007 17.2052 -0.00229158 17.9072 2.87193e-05 18.6159C2.87193e-05 20.0552 0.562306 21.4074 1.57813 22.4239C2.63124 23.4746 4.01052 24 5.38981 24C6.7691 24 8.14839 23.4746 9.19838 22.4239L18.8037 12.8183C20.2172 11.4008 21 9.51389 21 7.50884C21.0031 5.50068 20.2203 3.61376 18.8037 2.19623Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-file'"
    :width="width ? width : 17"
    :height="height ? height : 20"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 0V6C8.5 6.53043 8.72388 7.03914 9.1224 7.41421C9.52091 7.78929 10.0614 8 10.625 8H17V18C17 18.5304 16.7761 19.0391 16.3776 19.4142C15.9791 19.7893 15.4386 20 14.875 20H2.125C1.56141 20 1.02091 19.7893 0.622398 19.4142C0.223883 19.0391 0 18.5304 0 18V2C0 1.46957 0.223883 0.960859 0.622398 0.585786C1.02091 0.210714 1.56141 0 2.125 0H8.5ZM10.0938 0.5V6C10.0938 6.13261 10.1497 6.25979 10.2493 6.35355C10.349 6.44732 10.4841 6.5 10.625 6.5H16.4688L10.0938 0.5Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-clear'"
    :width="width ? width : 48"
    :height="height ? height : 48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.8 38.05v-3.4h7.7v3.4Zm0-19.5v-3.4h14.45v3.4Zm0 9.8V24.9H43v3.45ZM5.05 14.25H2.8v-4.6h9.05v-2.2h7.85v2.2h9.05v4.6H26.5V34.5q0 1.85-1.35 3.2t-3.25 1.35H9.6q-1.85 0-3.2-1.35t-1.35-3.2Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-select'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M5 21q-.825 0-1.413-.587Q3 19.825 3 19V5q0-.825.587-1.413Q4.175 3 5 3h14q.2 0 .375.037q.175.038.35.113L17.875 5H5v14h14v-6.65l2-2V19q0 .825-.587 1.413Q19.825 21 19 21Zm6.525-4l-5.65-5.65l1.4-1.4l4.25 4.25L20.7 5.025L22.125 6.4Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-microphone'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M12 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3m7 9c0 3.53-2.61 6.44-6 6.93V21h-2v-3.07c-3.39-.49-6-3.4-6-6.93h2a5 5 0 0 0 5 5a5 5 0 0 0 5-5h2Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-microphone-off'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M19 11c0 1.19-.34 2.3-.9 3.28l-1.23-1.23c.27-.62.43-1.31.43-2.05H19m-4 .16L9 5.18V5a3 3 0 0 1 3-3a3 3 0 0 1 3 3v6.16M4.27 3L21 19.73L19.73 21l-4.19-4.19c-.77.46-1.63.77-2.54.91V21h-2v-3.28c-3.28-.49-6-3.31-6-6.72h1.7c0 3 2.54 5.1 5.3 5.1c.81 0 1.6-.19 2.31-.52l-1.66-1.66L12 14a3 3 0 0 1-3-3v-.72L3 4.27L4.27 3Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-video'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11l-4 4Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-video-off'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M3.27 2L2 3.27L4.73 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12c.2 0 .39-.08.54-.18L19.73 21L21 19.73M21 6.5l-4 4V7a1 1 0 0 0-1-1H9.82L21 17.18V6.5Z"
    />
  </svg>
  <svg
    v-else-if="icon === 'chat-drag&drop'"
    :width="width ? width : 48"
    :height="height ? height : 48"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill-rule="nonzero"
        d="M14 6h2v2h5a1 1 0 0 1 1 1v7.5L16 13l.036 8.062 2.223-2.15L20.041 22H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zm8 11.338V21a1 1 0 0 1-.048.307l-1.96-3.394L22 17.338zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'chat-copy'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width ? width : 24"
    :height="height ? height : 24"
    viewBox="0 0 24 24"
  >
    <path
      :fill="color"
      d="M19 21H8V7h11m0-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-3-4H4a2 2 0 0 0-2 2v14h2V3h12V1Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'iconsButton',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#F2F2F2',
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style scoped lang="scss">
.copy {
  polyline {
    animation: anim;
    animation-duration: 2s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;

    -moz-animation: anim;
    -moz-animation-duration: 2s;
    -moz-animation-delay: 0.3s;
    -moz-animation-fill-mode: forwards;
    -moz-animation-timing-function: ease-out;
  }

  @keyframes anim {
    0% {
      stroke-dashoffset: 200;
    }
    50% {
      stroke-dashoffset: 50;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
}

svg {
  path {
    transition: 0.3s !important;
  }
}
</style>
